import _Object$setPrototypeOf from 'babel-runtime/core-js/object/set-prototype-of';
import _Object$create from 'babel-runtime/core-js/object/create';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = _Object$create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (_Object$setPrototypeOf) {
    _Object$setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

export var SplitError = function (_extendableBuiltin2) {
  _inherits(SplitError, _extendableBuiltin2);

  function SplitError() {
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Split Error';

    _classCallCheck(this, SplitError);

    var _this = _possibleConstructorReturn(this, (SplitError.__proto__ || _Object$getPrototypeOf(SplitError)).call(this, msg));

    _this.message = msg;
    return _this;
  }

  return SplitError;
}(_extendableBuiltin(Error));
export var SplitTimeoutError = function (_SplitError) {
  _inherits(SplitTimeoutError, _SplitError);

  function SplitTimeoutError(msg) {
    _classCallCheck(this, SplitTimeoutError);

    return _possibleConstructorReturn(this, (SplitTimeoutError.__proto__ || _Object$getPrototypeOf(SplitTimeoutError)).call(this, msg || 'Split Timeout Error'));
  }

  return SplitTimeoutError;
}(SplitError);
export var SplitNetworkError = function (_SplitError2) {
  _inherits(SplitNetworkError, _SplitError2);

  function SplitNetworkError(msg, code) {
    _classCallCheck(this, SplitNetworkError);

    var _this3 = _possibleConstructorReturn(this, (SplitNetworkError.__proto__ || _Object$getPrototypeOf(SplitNetworkError)).call(this, msg || 'Split Network Error'));

    _this3.statusCode = code;
    return _this3;
  }

  return SplitNetworkError;
}(SplitError);